import inServerContext from 'bundles/ssr/util/inServerContext';

export default () => inServerContext;
